import * as React from 'react'
import type { SVGIllustrationProps } from '../BaseIllustration'
import { BaseIllustration } from '../BaseIllustration'

export const MailboxIllustration = (props: SVGIllustrationProps) => (
  <BaseIllustration xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 240 160" {...props}>
    <path fill="#B2B2B2" d="M124.951 101.609v53.973l-5.28-2.64V98.969z" />
    <path fill="#C6C6C6" d="M124.951 101.609v53.973l9.289-1.662V99.947z" />
    <path
      fill="#FCCE09"
      d="M162.889 22.018c-2.934-1.467-7.334-1.858-10.169-1.271L72.249 34.63l29.235 33.342v48.889l80.471-14.178v-49.28c0-13.395-7.04-25.422-19.066-31.386"
    />
    <path
      fill="#FDDE84"
      d="M162.889 22.018c-2.934-1.467-7.334-1.858-10.169-1.271L72.249 34.63l4.204 4.791 89.662-15.547c-.977-.684-2.053-1.369-3.226-1.857"
    />
    <path
      fill="#DDAC0E"
      d="M101.484 67.974a35.31 35.31 0 0 0-19.653-31.68l-.782-.392c-9.094-4.497-19.654 2.054-19.654 12.223v48.888l40.187 19.947z"
    />
    <g opacity={0.6}>
      <path
        fill="url(#dhl__illustrations_mailboxillustration_svg_a)"
        d="M100.213 32.676c-2.933-1.467-7.333-1.858-10.169-1.272L83.69 32.48c2.835-.587 7.235-.195 10.169 1.271 12.026 5.965 19.066 17.991 19.066 31.387v9.484l6.356-1.075v-9.485c0-13.395-6.942-25.422-19.067-31.386"
        opacity={0.3}
      />
    </g>
    <path fill="#823C0D" d="M114.391 18.205v57.297l-1.467-.782v-57.2z" />
    <path fill="#BC5F20" d="M114.391 30.231v45.271l6.356-1.173V29.058z" />
    <path fill="#823C0D" d="m114.391 75.502-1.467-.782s-.293 4.693 4.596 4.498z" />
    <path
      fill="#BC5F20"
      d="M114.391 74.231v2.445a2.658 2.658 0 0 0 3.129 2.64l.489-.098c1.564-.294 2.738-1.662 2.738-3.227v-2.933zM114.391 18.205v13.297l14.96-4.009V14.978z"
    />
    <path fill="#99460E" d="m129.351 14.978-14.96 3.226-1.467-.684 14.96-3.324z" />
    <path
      fill="url(#dhl__illustrations_mailboxillustration_svg_b)"
      d="m66.578 67.484 24.64 12.32v-8.409L69.12 60.445l-2.542.488z"
      opacity={0.3}
    />
    <path fill="#BC5F20" d="M86.524 70.711v4.4l1.467-.293v-4.302z" />
    <path fill="#823C0D" d="M86.524 70.711v4.4l-19.946-9.973v-4.303z" />
    <path fill="#BC5F20" d="M86.524 70.711v1.467l4.694-.782v-1.467z" />
    <path fill="#99460E" d="m86.524 70.711 4.694-.782-19.947-9.973-4.693.88z" />
    <defs>
      <linearGradient
        id="dhl__illustrations_mailboxillustration_svg_a"
        x1={99.68}
        x2={109.548}
        y1={39.99}
        y2={68.447}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity={0} />
        <stop offset={0.161} stopOpacity={0} />
        <stop offset={0.826} />
      </linearGradient>
      <linearGradient
        id="dhl__illustrations_mailboxillustration_svg_b"
        x1={77.65}
        x2={81.007}
        y1={72.933}
        y2={65.925}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity={0} />
        <stop offset={0.161} stopOpacity={0} />
        <stop offset={0.826} />
      </linearGradient>
    </defs>
  </BaseIllustration>
)
